import React from 'react';
import CreateCommentForm from './create-comment-form';
import CommentsList from './comments-list';
import Skeleton from '../../../../../components/Skeleton';
import LoginPrompt from '../login-prompt';

const CommentsSection = React.memo(({postId, isAuthorized, currentUserId}) => {
    const [lastCreatedCommentId, setLastCreatedCommentId] = React.useState(null);
    const [showLoginPrompt, setShowLoginPrompt] = React.useState(false);

    const handleShowLoginPrompt = React.useCallback(() => {
        setShowLoginPrompt(true);
    }, []);

    return (
        <div className='padding-top-1rem padding-left-2rem'>
            <div className='padding-top-1rem padding-bottom-1rem padding-left-1rem border-left-style-solid border-left-width-0dot125rem border-left-color-gray-300'>
                <div className='position-relative'>
                    <div
                        className='position-absolute top-1dot25rem border-bottom-style-solid border-bottom-width-0dot125rem border-bottom-color-gray-500 pointer-events-none'
                        style={{left: '-0.8rem', width: '0.6rem'}}
                    />
                    <CreateCommentForm
                        parentPostId={postId}
                        isAuthorized={isAuthorized}
                        onShowLoginPrompt={handleShowLoginPrompt}
                        onCommentCreated={(newId) => {
                            if (newId) setLastCreatedCommentId(newId);
                        }}
                    />
                    {showLoginPrompt && (
                        <LoginPrompt postId={postId} />
                    )}
                </div>
                <React.Suspense fallback={
                    <div className='padding-1rem'>
                        <Skeleton/>
                    </div>
                }>
                    <div className='padding-top-1rem mw768-padding-top-1dot5rem'>
                        <CommentsList 
                            postId={postId}
                            currentUserId={currentUserId}
                            isAuthorized={isAuthorized}
                            highlightId={lastCreatedCommentId}
                        />
                    </div>
                </React.Suspense>
            </div>
        </div>
    );
});

export default CommentsSection;

